import { useState } from "react";
import { View } from "react-native";
import Loading from "src/components/Loading";
import PillButton from "src/components/PillButton";
import Touchable from "src/components/Touchable";
import useDim from "src/hooks/useDim";
import IconClose from "src/icons/IconClose";
import { useInsideModal } from "src/modals";
import PublicGatheringModal from "src/modals/configs/PublicGatheringModal";
import PhotoDisplay from "src/screens/(internal)/PhotoDetailModal/components/MainPhotoItem/components/MainPhotoItemContent/components/PhotoDisplay";
import { paddingLarge, paddingMedium } from "src/styles/spacing";
import { useSafeArea } from "src/swsh-native";
import PhotoPublicPreviewFooter from "./components/PhotoPublicPreviewFooter";
import PhotoPublicReport from "./components/PhotoPublicReport";

const PhotoPublicPreviewModal = () => {
	const safeArea = useSafeArea();
	const { props, closeSelf } = useInsideModal<PublicGatheringModal["PhotoPublicPreviewModal"]>();
	const [mainDim, setMainDim] = useState<{ width: number; height: number } | null>(null);
	const dim = useDim();

	const [didLoad, setDidLoad] = useState(false);
	return (
		<>
			<Touchable
				animation="None"
				onPress={closeSelf}
				containerStyle={{
					width: dim.width,
					height: dim.height,
				}}
			/>
			<View
				testID="PublicPreview"
				pointerEvents="box-none"
				style={[
					{
						position: "absolute",
						width: dim.width,
						height: dim.height,
						paddingTop: safeArea.top,
						paddingBottom: safeArea.bottom,
					},
				]}
			>
				<View
					pointerEvents="box-none"
					style={{
						alignItems: "center",
						justifyContent: "space-between",
						marginVertical: paddingLarge,
						paddingHorizontal: paddingLarge,
						flexDirection: "row",
					}}
				>
					<PillButton Icon={IconClose} onPress={closeSelf} />
					<PhotoPublicReport photoId={props.photo.photoId} />
				</View>
				<View
					pointerEvents="box-none"
					style={{
						marginTop: paddingMedium,
						flex: 1,
						alignItems: "center",
						justifyContent: "center",
					}}
					onLayout={(event) => {
						const { width, height } = event.nativeEvent.layout;
						if (width === 0 || height === 0) return;
						setMainDim({ width, height });
					}}
				>
					{!didLoad && (
						<Loading
							style={{
								position: "absolute",
							}}
						/>
					)}
					{mainDim && (
						<PhotoDisplay
							photo={props.photo}
							boundingWidth={mainDim.width}
							boundingHeight={mainDim.height}
							isActive
							onLoad={() => setDidLoad(true)}
						/>
					)}
				</View>
				<PhotoPublicPreviewFooter photo={props.photo} />
			</View>
		</>
	);
};
export default PhotoPublicPreviewModal;
